import { Reducer } from 'redux';
import { DataExportState, DataExportStatus } from './DataExportState';
import {
    DataExportAction,
    DATA_EXPORT_START,
    DATA_EXPORT_SUCCESS,
    DATA_EXPORT_ERROR,
    DATA_EXPORT_RESET
} from 'actions/dataExport/DataExportActionsTypes';

/**
 * Initial state for Data Export
 */
const initialState: DataExportState = {
    status: DataExportStatus.Idle,
    loading: false,
    error: null
};

/**
 * Data Export reducer
 */
export const dataExportReducer: Reducer<DataExportState, DataExportAction> = (state = initialState, action) => {
    switch (action.type) {
        case DATA_EXPORT_START:
            return {
                ...state,
                status: DataExportStatus.Exporting,
                loading: true,
                error: null
            };
        case DATA_EXPORT_SUCCESS:
            return {
                ...state,
                status: DataExportStatus.ExportSuccess,
                loading: false,
                error: null
            };
        case DATA_EXPORT_ERROR:
            return {
                ...state,
                status: DataExportStatus.ExportError,
                loading: false,
                error: action.payload.error
            };
        case DATA_EXPORT_RESET:
            return initialState;
        default:
            return state;
    }
};

export default dataExportReducer;
